import axios from './axios.js';
// import Vue from 'vue';
import router from '@/router';
import { Message } from 'element-ui';
import store from '@/store';
import { getToken, removeToken } from '@/utils/auth';
import _ from 'lodash';
import { getEnvGlobalConfig } from '@/utils';
import i18n from '../lang';

// 存储请求信息和取消方法的的map对象
const pendingRequest = new Map();

// 根据请求生成对应的key
function getRequestKey(config) {
  const { method, url, params, data } = config;
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&');
}

// 删除请求信息
export function delPendingRequest(config) {
  const requestKey = getRequestKey(config);
  if (pendingRequest.has(requestKey)) {
      pendingRequest.delete(requestKey);
  }
}

function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

function getErrorMessage(data, fallback) {
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (typeof data === 'number' || typeof data === 'boolean') return String(data);
  if (Array.isArray(data)) {
    const firstMessage = data.map(item => getErrorMessage(item, '')).find(Boolean);
    return firstMessage || fallback;
  }
  if (typeof data === 'object') {
    return data.msg || data.message || data.error || data.error_description || fallback;
  }
  return fallback;
}

const CONTENT_TYPES = {
  1: 'application/json',
  2: 'multipart/form-data',
  3: 'application/x-www-form-urlencoded',
  4: 'text/plain',
};
const RESPONSE_TYPES = {
  0: 'text',
  1: 'json',
  2: 'blob',
  3: 'buffer',
};
// // create an axios instance

const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
});

// // request interceptor
service.interceptors.request.use(config => {
    if (!config.loadingHide) store.dispatch('app/addLoadingCount');
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken();
    }

    // 根据请求的信息(请求方式,url,请求get/post数据),产生map的key
    const requestKey = getRequestKey(config);
    // 判断请求是否重复
    if (pendingRequest.has(requestKey) && !config.url.includes('/labels/labelList')) {
        // 取消上次请求
        const cancel = pendingRequest.get(requestKey);
        cancel();
        // 删除请求信息
        pendingRequest.delete(requestKey);
    }
    // 把请求信息,添加请求到map当中
    // 生成取消方法
    config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
        // 把取消方法添加到map
        if (!pendingRequest.has(requestKey)) {
            pendingRequest.set(requestKey, cancel);
        }
    });
    return config;
  },
  error => {
    // do something with request error
    // console.error(error); // for debug
    return Promise.reject(error);
  },
);

// // response interceptor
service.interceptors.response.use(async response => {
    const config = response && response.config;

    await sleep(config.loadingMore);

    if (!config.loadingHide) store.dispatch('app/addLoadingCount', false);

    const OLD_RESPONSE_DATA = response.data;
    let NEW_RESPONSE_DATA = null;

    if (
      (response.status === 204 || response.status === 200) &&
      (typeof OLD_RESPONSE_DATA === 'string' || typeof OLD_RESPONSE_DATA === 'number')
    ) {
      NEW_RESPONSE_DATA = {
        failed: false,
        message: OLD_RESPONSE_DATA || '操作成功',
      };
    }

    if (
      (response.status === 204 || response.status === 200) &&
      typeof OLD_RESPONSE_DATA === 'boolean'
    ) {
      NEW_RESPONSE_DATA = {
        failed: !OLD_RESPONSE_DATA,
        message: OLD_RESPONSE_DATA ? '操作成功' : 'Waring',
      };
    }

    const res = NEW_RESPONSE_DATA || OLD_RESPONSE_DATA || response;
    /**
     * 统一处理 ： 接口连接正常，但 res.failed==true 的情况
     */
    if (response.config.url.indexOf('billing') > 0 && response.data.code && response.data.code != 200) {
      Message({
        message: response.data.msg || response.data.message, // error.message
        type: 'error',
        duration: 2 * 1000,
      });
      return Promise.reject({
        failed: true,
        code: response.data.code,
        message: response.data.msg || response.data.message || '',
      });
    }

    if (res && res.failed && !config.errorHide) {
      const tip = res && res.message == '数据操作错误，请联系管理员' ? i18n.t('errorApi') : res.message;
      const alreadyConfirmed = config.url.includes('/mass/confirmEmail/') && res.message === 'email already confirmed';
      Message({
        message: tip, // error.message
        type: alreadyConfirmed ? 'warning' : 'error',
        duration: 2 * 1000,
      });
    }
    // if (response?.data?.code && response.data.code != 200) {
    //   Message({
    //     message: response.data.msg, // error.message
    //     type: 'error',
    //     duration: 2 * 1000,
    //   });
    // }
    delPendingRequest(response.config);
    return res;
    // if the custom code is not 0, it is judged as an error.
    // if (res.code === null || (res.code && res.code !== 0)) {
    //   if (res.code === 100008005 && res.data && Array.isArray(res.data) && res.data.length > 0) {
    //     Message({
    //       message: res.data[0].msg || 'Error',
    //       type: 'error',
    //       duration: 5 * 1000,
    //     });
    //   } else {
    //     Message({
    //       message: res.message || 'Error',
    //       type: 'error',
    //       duration: 5 * 1000,
    //     });
    //   }
    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm(
    //       'You have been logged out, you can cancel to stay on this page, or log in again',
    //       'Confirm logout',
    //       {
    //         confirmButtonText: 'Re-Login',
    //         cancelButtonText: 'Cancel',
    //         type: 'warning',
    //       },
    //     ).then(() => {
    //       store.dispatch('app/user/resetToken').then(() => {
    //         location.reload();
    //       });
    //     });
    //   }
    //   if (store.getters.globalPartialLoading) {
    //     setTimeout(() => {
    //       store.dispatch('app/toggleGlobalLoading', false);
    //     }, 700);
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'));
    // } else {
    //   if (store.getters.globalPartialLoading) {
    //     setTimeout(() => {
    //       store.dispatch('app/toggleGlobalLoading', false);
    //     }, 700);
    //   }

    //   return res;
    // }
  },
  error => {
    const config = error && error.config;
    if (config && !config.loadingHide) store.dispatch('app/addLoadingCount', false);
    // if (store.getters.globalPartialLoading) {
    //   setTimeout(() => {
    //     store.dispatch('app/toggleGlobalLoading', false);
    //   }, 700);
    // }
    console.log(error, error.response, error.response.status);
    if (error && error.response && error.response.status) {
      switch (error.response.status) {
        case 500:
          Message({
            showClose: true,
            message: getErrorMessage(error.response.data, `${i18n.t('errorApi')}(${error.response.status})`),
            type: 'error',
            duration: 10 * 1000,
          });
          break;
        case 503:
          // do something...
          Message({
            showClose: true,
            message: `${i18n.t('errorApi')}(${error.response.status})`,
            type: 'error',
            duration: 10 * 1000,
          });
          break;
        case 404:
          // do something...
          Message({
            message: `${i18n.t('errorApi')}(${error.response.status})`,
            type: 'error',
            duration: 5 * 1000,
          });
          break;
        case 403:
          // do something...
          Message({
            message: `${i18n.t('errorApi')}(${error.response.status})`,
            type: 'error',
            duration: 5 * 1000,
          });
          break;
        case 401:
          // do something...
          if (location.href.indexOf('dingHours') > -1) {
            removeToken();
            window.location.reload();
          } else {
            if (!getEnvGlobalConfig('VUE_APP_ACCESS_TOKEN')) {
              Message({
                message: `${i18n.t('loginTip')}`, // error.message
                type: 'error',
                duration: 2 * 1000,
              });
              setTimeout(() => {
                store.dispatch('user/resetInfo').then(() => {
                  router.replace({
                    path: '/login',
                  });
                });
              }, 1000);
            }
          }
          break;
        default:
          // do something...
          // Message({
          //   message: '服务器开小差了~', // error.message
          //   type: 'error',
          //   duration: 5 * 1000,
          // });
          break;
      }
    } else {
      // Message({
      //   message: '服务器开小差了~', // error.message
      //   type: 'error',
      //   duration: 5 * 1000,
      // });
    }
    if (error?.message?.includes('timeout')) {
      // 判断请求异常信息中是否含有超时timeout字符串
      Message({
        showClose: true,
        message: `${i18n.t('errorApi2')}`, // error.message
        type: 'error',
        duration: 10 * 1000,
      });
      return Promise.reject({
        failed: true,
        message: '',
      });
    }
    if (!axios.isCancel(error)) {
      // 服务器报400,500报错,删除请求信息
      delPendingRequest(error.config || {});
    }
    console.log(1111, error.config);
    return Promise.reject({
      failed: true,
      message: 'Api Http Status Code : ' + (error.response && error.response.status),
    });
  },
);

export function ajax(method = 'post', url, options, header = {}) {
  method = method.toLowerCase();
  options.data = options.data || {};
  let requestType = (options.type || '').toLowerCase();
  // data参数指定隐藏loading动画
  const BjAjaxLoadingHide = options.data.BjAjaxLoadingHide;
  delete options.data.BjAjaxLoadingHide;
  const opts = {
    url,
    method,
    errorHide: !!options.errorHide,
    loadingHide: !!options.loadingHide || BjAjaxLoadingHide, // 此请求隐藏loading动画
    loadingMore: options.loadingMore || 0, // 此请求延迟loading，主动延迟返回（后端异步的情况）
    responseType: RESPONSE_TYPES[options.rType || '0'],
    timeout: options.timeout,
  };
  if (Object.prototype.toString.call(header) === '[object Object]') {
    opts.headers = {
      'Content-type': CONTENT_TYPES[options.cType || '1'],
      ...header,
    };
  } else {
    throw new Error('header 必须是个对象，' + header + '不是期望的值');
  }
  /**
   * 兼容rest风格（请求参数拼接在路径上）
   */
  let restfulUrl = '';
  if (url[url.length - 1] === '/') {
    // rest 风格的get 请求 需要api文件的url 最后拼接上/
    let restAPI = Object.values(options.data); // 取参数value数组
    if (typeof options.data === 'string') {
      restAPI = [options.data];
    }
    restfulUrl = opts.url + restAPI.join('/'); // 把参数拼接在url后面
    requestType = 'restful';
  }
  /**
   * 没有指定请求的类型，自动判断请求方式
   */
  if (!requestType) {
    if (method === 'get') {
      requestType = 'query';
    } else {
      requestType = 'body';
    }
  }
  if (requestType === 'query') {
    opts.params = options.data;
  }
  if (requestType === 'body') {
    opts.data = options.data;
  }
  if (requestType === 'form' && options.data) {
    const formData = new FormData();
    Object.keys(options.data).forEach(key => {
      formData.append(key, options.data[key]);
    });
    opts.data = formData;
  }
  if (requestType === 'restful') {
    opts.url = restfulUrl;
  }

  /** 特定奇葩的传参方式 */
  if (options.data && options.data.BjBody) {
    opts.data = options.data.BjBody;
  }
  if (options.data && options.data.BjQuery) {
    opts.params = options.data.BjQuery;
  }

  return service(opts);
}

export function generate(config) {
  const map = {};
  const items = config.items;
  for (let i = 0, len = items.length; i < len; i++) {
    map[items[i].key] = function(data) {
      /**
       * 把data里的值 替换到url上{}里，并删除data对应key
       */
      let tempUrl = (items[i].prefix || config.prefix || '') + items[i].url;
      const REG = /\{(.+?)\}/g;
      const __matchKey = tempUrl.match(REG); // 带{}花括号

      // 链接{}花括号参数处理
      if (Array.isArray(__matchKey)) {
        const matchKey = __matchKey.map(e => e.replace('{', '').replace('}', '')); // 去{}花括号
        matchKey.forEach((key, index) => {
          const __key = __matchKey[index];
          let __value;
          // {}花括号 从data中取值（如果有data.key的话）
          if (data && Object.prototype.hasOwnProperty.call(data, key)) {
            //  从data中取值（如果有data[key]的话）
            __value = data[key];
            if (
              (key === 'organizationId' || key === 'tenantId') &&
              (__value === null || __value === '' || __value === undefined || __value === 'default')
            ) {
              // data.organizationId 或 data.tenantId 是空值，从store中获取，默认为0租户
              __value = store.getters.tenantId || 0;
            }
            tempUrl = tempUrl.replace(__key, __value);
            delete data[key];
          } else {
            if (key === 'organizationId') {
              // data 没有 给 organizationId 赋值
              // if (store.getters.isSiteRole) {
                // 平台层，删除api链接中的/{organizationId}/
                // tempUrl = tempUrl.replace(__key + '/', '');
              // } else {
                // 租户层，替换api链接中的/{organizationId}/ 从store中获取当前角色的租户
                __value = store.getters.tenantId || 0;
                tempUrl = tempUrl.replace(__key, __value);
              // }
            } else if (key === 'tenantId') {
              // data 没有 给 tenantId 赋值
              // 替换api链接中的/{tenantId}/ 从store中获取当前角色的租户
              __value = store.getters.tenantId || 0;
              tempUrl = tempUrl.replace(__key, __value);
            } else {
              // 其它key的情况，未找到时提示错误
              console.error(`Can't find ${key} from the ${items[i].method} data`, data);
            }
          }
        });
      }
      // 默认值
      if (
        data &&
        Object.prototype.hasOwnProperty.call(data, 'tenantId') &&
        data.tenantId == 'default'
      ) {
        data.tenantId = store.getters.tenantId || 0;
      }
      if (
        data &&
        Object.prototype.hasOwnProperty.call(data, 'organizationId') &&
        data.organizationId == 'default'
      ) {
        data.organizationId = store.getters.tenantId || 0;
      }
      /** END */

      /**
       *  TODO: 从0开始的分页page */
      if (data && Object.prototype.hasOwnProperty.call(data, 'page') && data.page > 0) {
        data.page = data.page - 1;
      }
      /** END */
      return ajax(items[i].method, tempUrl, {
        data,
        ...(_.omit(items[i], ['key', 'url', 'method', 'prefix']) || {}),
      });
    };
  }
  return map;
}

export default {};
